


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { AreaForm } from '@/models/config'

// Components
import { FormCreateEditArea } from '@/components/config'

@Component({
    name: 'ModalCreateEditArea',
    components: {
        FormCreateEditArea
    }
})
export default class ModalCreateEditArea extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) area!: AreaForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nueva Area'
        }
        return 'Editar Area'
    }
}
